export default __webpack_public_path__ + "static/media/spotStories.184b8185.svg";